import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import TrackVisibility from "react-on-screen";
import Layout from "../components/Layout";
import Progress from "../components/Progress";
import Resume from "../components/Resume";
import Sectiontitle from "../components/Sectiontitle";
import Smalltitle from "../components/Smalltitle";
import Spinner from "../components/Spinner";
import ReactGA from "react-ga";
import config from "../config";

function initializeReactGA() {
  ReactGA.initialize("UA-176707724-1");
  ReactGA.set({ siteSpeedSampleRate: 100 });
  ReactGA.pageview("/ResumePage");
}

function Resumes() {
  initializeReactGA();
  const [skills, setSkills] = useState([]);
  const [workingExperience, setWorkingExperience] = useState([]);
  const [educationExperience, setEducationExperience] = useState([]);

  useEffect(() => {
    fetch(`${config.apiUrl}${config.apiBasePath}skills`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-Api-Key': config.apiKey
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setSkills(data);
      })
      .catch(error => {
        console.error('Error fetching skills:', error);
      });

    fetch(`${config.apiUrl}${config.apiBasePath}experiences`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-Api-Key': config.apiKey
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setWorkingExperience(data.workingExperience);
        setEducationExperience(data.educationExperience);
      })
      .catch(error => {
        console.error('Error fetching experience:', error);
      });
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Resume - Adrian Callies Portfolio</title>
        <meta
          name="description"
          content="Adrian Callies - Resume and Experience"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-skills-area mi-section mi-padding-top">
          <div className="container">
            <Sectiontitle title="My Skills" />
            <div className="mi-skills">
              <div className="row mt-30-reverse">
                {skills.map((skill) => (
                  <TrackVisibility
                    once
                    className="col-lg-6 mt-30"
                    key={skill.title}
                  >
                    <Progress title={skill.title} percentage={skill.value} />
                  </TrackVisibility>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mi-resume-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="Resume" />
            <Smalltitle title="Working Experience" icon="briefcase" />
            <div className="mi-resume-wrapper">
              {workingExperience.map((workingExp) => (
                <Resume key={workingExp.id} resumeData={workingExp} />
              ))}
            </div>
            <div className="mt-30"></div>
            <Smalltitle title="Educational Qualifications" icon="book" />
            <div className="mi-resume-wrapper">
              {educationExperience.map((educatonExp) => (
                <Resume key={educatonExp.id} resumeData={educatonExp} />
              ))}
            </div>
            <br />
            <br />
              <a
                href={"/files/Resume_Adrian_Callies_SWE.pdf"}
                target="_blank"
                rel="noopener noreferrer"
                className="mi-button"
                >
                Software Engineer Resume
              </a>
            <br />
            <br />
              <a
                href={"/files/Resume_Adrian_Callies_SE.pdf"}
                target="_blank"
                rel="noopener noreferrer"
                className="mi-button"
                >
                Sales Engineer Resume
              </a>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Resumes;
